import FingerprintJS from '@fingerprintjs/fingerprintjs'

let cached: string | null = null
let loading: Promise<string | null> | null = null

const getFingerprint = (): Promise<string | null> => {
  if (cached !== null) {
    return Promise.resolve(cached)
  }

  if (loading !== null) {
    return loading
  }

  loading = FingerprintJS.load()
    .then((fp) => fp.get())
    .then((result) => {
      cached = result.visitorId
      loading = null
      return cached
    })
    .catch((err) => {
      console.warn('[deviceFingerprint] collection failed:', err)
      loading = null
      return null
    })

  return loading
}

const deviceFingerprintService = { getFingerprint }

export default deviceFingerprintService
